  let tab = document.querySelectorAll('.tab-menu-trimmer');
  let collectionList = document.querySelectorAll('.tab-collection-product');

  let printProduct = document.querySelector('.custompdp-1');
  let printProduct2 = document.querySelector('.custompdp-2');
  let printProduct3 = document.querySelector('.custompdp-3');

  tab.forEach((menu) => {
    menu.addEventListener("click", () => {
      let tabAttribute = menu.getAttribute('dataid');
    tab.forEach((item) => item.classList.remove('tab-color'));
    menu.classList.add('tab-color');
      collectionList.forEach((collectionProduct) => {
        let collectionAttribute = collectionProduct.getAttribute('id');
        
        if (tabAttribute === collectionAttribute) {
          collectionProduct.style.display = 'block';
          collectionProduct.classList.add('collection-index');
        } else {
          collectionProduct.style.display = 'none';
          collectionProduct.classList.remove('collection-index');
        }
      });
    });
  });

if (window.innerWidth >= 480) {
    let data = document.querySelectorAll('.meta-image-pdp');
    data.forEach((i) => {
        let nearParent = i.closest('.custom-card');
        if (nearParent) {
            nearParent.style.padding = '0';
        }
    });
}
  $(document).ready(function () {
    $('.page-banner-section img:first').show();
    $('.page-banner-section img').hide();

    function initializeSlider() {
      if (!$('.page-banner-section').hasClass('slick-initialized')) {
        $('.page-banner-section img').show(); 

        $('.page-banner-section').slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          arrows: false,
          dots: true
        });

      $('.page-banner-section > *').css("display", "block");

      }
    }
      initializeSlider();
  });

  $(function () {
  const $allVideos = $("video");

  $(".insta-gram-videos .videos-alignment").each(function () {
    const $container = $(this);
    const video = $container.find("video").get(0);
    const $playButton = $container.find(".video-play-btn");
    const $pauseButton = $container.find(".video-paused-btn");
    const $cover = $container.find(".video-cover");

    let hideControlsTimeout;

    function hideControlsSoon() {
      clearTimeout(hideControlsTimeout);
      hideControlsTimeout = setTimeout(() => {
        if (!video.paused) $pauseButton.hide();
      }, 3000);
    }

    function showPausedUI() {
      $container.removeClass("is-playing");
      $playButton.css("display", "flex");
      $pauseButton.hide();
      clearTimeout(hideControlsTimeout);
      if ($cover.length) $cover.show();
    }

    function showPlayingUI() {
      $container.addClass("is-playing");
      $playButton.hide();
      $pauseButton.css("display", "flex");
      if ($cover.length) $cover.show(); // opacity handled by CSS via .is-playing
      hideControlsSoon();
    }

    // Start state
    showPausedUI();

    // Pause all other videos helper
    function pauseOthers() {
      $allVideos.each(function () {
        if (this !== video) {
          this.pause();
          const $other = $(this).closest(".videos-alignment");
          $other.removeClass("is-playing");
          $other.find(".video-play-btn").css("display", "flex");
          $other.find(".video-paused-btn").hide();
          $other.find(".video-cover").show();
        }
      });
    }

    // Clicks
    $playButton.on("click", function () {
      pauseOthers();
      if (video.paused) {
        video.play();
        showPlayingUI();
      }
    });

    $pauseButton.on("click", function () {
      if (!video.paused) {
        video.pause();
        showPausedUI();
      }
    });

    // Cover par click = Play
    $cover.on("click", function () {
      pauseOthers();
      if (video.paused) {
        video.play();
        showPlayingUI();
      }
    });

    // Container hover / leave
    $container.on("mouseenter", function () {
      if (video.paused) {
        $playButton.css("display", "flex");
        $pauseButton.hide();
      } else {
        $pauseButton.css("display", "flex");
        $playButton.hide();
      }
      clearTimeout(hideControlsTimeout);
    });

    $container.on("mouseleave", function () {
      hideControlsSoon();
    });

    // Video events
    $(video).on("play", function () {
      showPlayingUI();
    });

    $(video).on("pause ended", function () {
      showPausedUI();
    });

    $(video).on("click mousemove", function () {
      if (video.paused) {
        $playButton.css("display", "flex");
        $pauseButton.hide();
      } else {
        $pauseButton.css("display", "flex");
        $playButton.hide();
      }
      hideControlsSoon();
    });
  });
});

